var map = {
	"./accessibility.json": "./src/js/locales/en/accessibility.json",
	"./accordion.json": "./src/js/locales/en/accordion.json",
	"./action.json": "./src/js/locales/en/action.json",
	"./agGrid.json": "./src/js/locales/en/agGrid.json",
	"./ai.json": "./src/js/locales/en/ai.json",
	"./button.json": "./src/js/locales/en/button.json",
	"./componentSettings.json": "./src/js/locales/en/componentSettings.json",
	"./config.json": "./src/js/locales/en/config.json",
	"./connection.json": "./src/js/locales/en/connection.json",
	"./dataImport.json": "./src/js/locales/en/dataImport.json",
	"./datepicker.json": "./src/js/locales/en/datepicker.json",
	"./errors.json": "./src/js/locales/en/errors.json",
	"./exports.json": "./src/js/locales/en/exports.json",
	"./filepond.json": "./src/js/locales/en/filepond.json",
	"./files.json": "./src/js/locales/en/files.json",
	"./filters.json": "./src/js/locales/en/filters.json",
	"./forms.json": "./src/js/locales/en/forms.json",
	"./general.json": "./src/js/locales/en/general.json",
	"./grids.json": "./src/js/locales/en/grids.json",
	"./groupButtons.json": "./src/js/locales/en/groupButtons.json",
	"./header.json": "./src/js/locales/en/header.json",
	"./home.json": "./src/js/locales/en/home.json",
	"./locale.json": "./src/js/locales/en/locale.json",
	"./notFound.json": "./src/js/locales/en/notFound.json",
	"./onedrive.json": "./src/js/locales/en/onedrive.json",
	"./personalSettings.json": "./src/js/locales/en/personalSettings.json",
	"./policyManager.json": "./src/js/locales/en/policyManager.json",
	"./processMaps.json": "./src/js/locales/en/processMaps.json",
	"./repeaters.json": "./src/js/locales/en/repeaters.json",
	"./reports.json": "./src/js/locales/en/reports.json",
	"./search.json": "./src/js/locales/en/search.json",
	"./select.json": "./src/js/locales/en/select.json",
	"./stopwatch.json": "./src/js/locales/en/stopwatch.json",
	"./syncfusion.json": "./src/js/locales/en/syncfusion.json",
	"./validation.json": "./src/js/locales/en/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js/locales/en sync recursive \\.json$";